export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-300/50">
      <div className="max-w-[1024px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-fill text-foreground-50 text-lg"></i>
              </div>
              <span className="text-foreground-200 font-bold text-base whitespace-nowrap">
                四虎影视大全
              </span>
            </div>
            <p className="text-foreground-500 text-xs leading-relaxed mb-4">
              四虎影视大全提供高清免费在线观看服务，涵盖电视剧、电影等海量资源，无需付费即可流畅观看。每日更新最新影视，高清画质不缓冲，是您最值得信赖的在线观影平台。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-300 mb-4 whitespace-nowrap">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#ranking" className="text-foreground-500 text-xs hover:text-primary-400 transition-colors cursor-pointer">热播榜单</a>
              </li>
              <li>
                <a href="#index" className="text-foreground-500 text-xs hover:text-primary-400 transition-colors cursor-pointer">影视专题</a>
              </li>
              <li>
                <a href="#updates" className="text-foreground-500 text-xs hover:text-primary-400 transition-colors cursor-pointer">最新动态</a>
              </li>
              <li>
                <a href="#carousel" className="text-foreground-500 text-xs hover:text-primary-400 transition-colors cursor-pointer">焦点专题</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-300 mb-4 whitespace-nowrap">关于平台</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#about" className="text-foreground-500 text-xs hover:text-primary-400 transition-colors cursor-pointer">关于我们</a>
              </li>
              <li>
                <a href="#faq" className="text-foreground-500 text-xs hover:text-primary-400 transition-colors cursor-pointer">常见问题</a>
              </li>
              <li>
                <a href="#features" className="text-foreground-500 text-xs hover:text-primary-400 transition-colors cursor-pointer">平台优势</a>
              </li>
              <li>
                <a href="#contact" className="text-foreground-500 text-xs hover:text-primary-400 transition-colors cursor-pointer">意见反馈</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-300 mb-4 whitespace-nowrap">合作伙伴</h4>
            <p className="text-foreground-600 text-xs">更多合作伙伴即将揭晓，敬请期待。</p>
          </div>
        </div>

        <div className="border-t border-background-300/40 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-600 text-xs">
            &copy; 2026 四虎影视大全 版权所有 | 高清免费在线观看
          </p>
          <div className="flex items-center gap-4 text-foreground-600 text-xs">
            <a href="#hero" className="hover:text-foreground-400 transition-colors cursor-pointer">服务条款</a>
            <a href="#hero" className="hover:text-foreground-400 transition-colors cursor-pointer">隐私政策</a>
            <a href="#hero" className="hover:text-foreground-400 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}